import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
export default class StoreFactory {
}
StoreFactory.defaultConfig = {
    middlewares: [],
    reduxLoggerEnable: false,
    reducers: [],
};
StoreFactory.create = (config = {}) => {
    const { middlewares = [], reduxLoggerEnable, reducers = [] } = Object.assign({}, StoreFactory.defaultConfig, config);
    const composeEnhancers = typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }) : compose;
    const _middlewares = [
        thunkMiddleware
    ].concat(middlewares);
    if (reduxLoggerEnable && process.env.NODE_ENV === 'development') {
        _middlewares.push(require('redux-logger').createLogger());
    }
    const enhancer = composeEnhancers(applyMiddleware(..._middlewares));
    const rootReducer = StoreFactory.combineReducers(...reducers);
    return createStore(rootReducer, enhancer);
};
StoreFactory.combineReducers = (...reducerClasses) => {
    const reducers = {};
    reducerClasses.map(clazz => {
        Object.keys(clazz).map(name => {
            Object.assign(reducers, { [name]: clazz[name] });
        });
    });
    return combineReducers(reducers);
};
